import {
	BarChart3,
	FileText,
	FolderPlus,
	MessageSquare,
	Users,
} from "lucide-react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuthCache } from "@/shared/cache";
import { AppShell } from "@/v2/components/AppShell";
import type { NavItem } from "@/v2/components/MobileBottomNav";
import { TimerProvider } from "@/v2/contexts/TimerProvider";

const dashboardNavItem: NavItem = {
	path: "/admin/dashboard",
	label: "Dashboard",
	icon: BarChart3,
};

const billingNavItem: NavItem = {
	path: "/admin/billing",
	label: "Billing",
	icon: FileText,
};

const mattersNavItem: NavItem = {
	path: "/admin/matters",
	label: "Matters",
	icon: FolderPlus,
};

const secondaryNavItems: NavItem[] = [
	{ path: "/admin/timekeeper", label: "Timekeeper", icon: Users },
	{ path: "/admin/support", label: "Support", icon: MessageSquare },
];

export default function V2AdminLayout() {
	const { auth } = useAuthCache();
	const navigate = useNavigate();
	const hasStandardAdminAccess =
		auth.adminPermissions.overview ||
		auth.adminPermissions.billing ||
		auth.adminPermissions.entries ||
		auth.adminPermissions.calendar ||
		auth.adminPermissions.support;
	const visibleNavItems = hasStandardAdminAccess
		? [
				dashboardNavItem,
				...(auth.adminPermissions.billing ? [billingNavItem] : []),
				...(auth.adminPermissions.matters ? [mattersNavItem] : []),
				...secondaryNavItems,
			]
		: [mattersNavItem];

	return (
		<TimerProvider>
			<AppShell
				navItems={visibleNavItems}
				userInitials={auth.initials}
				userDisplayName={auth.displayName}
				userEmail={auth.email}
				showRoleSwitcher
				currentRole="admin"
				onRoleSwitch={() => navigate("/entries")}
			>
				<Outlet />
			</AppShell>
		</TimerProvider>
	);
}
